<template>
    <div>
        <div style="margin-bottom: 28px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;" class="flex-wrap">
            <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">Pemakaian QR per Dealer</h2>
            <div class="d-flex flex-row flex-wrap align-items-center">
                <div class="mr-3 d-flex">
                    <div class="mr-2" style="font-size: 15px;">Total Seluruh QR : {{numberWithCommas(totalQr)}}</div>
                    <i id="totalQr"><img src="@/assets/img/icon/info-square.svg" alt=""></i>
                    <b-popover
                    target="totalQr"
                    triggers="hover focus"
                    placement="bottom"
                    :content="'Jumlah stock QR seluruh dealer'"
                    ></b-popover>
                </div>
                <div class="mr-3 d-flex">
                    <div class="mr-2" style="font-size: 15px;">All time used QR : {{numberWithCommas(usedQr)}}</div>
                    <i id="totalUsed"><img src="@/assets/img/icon/info-square.svg" alt=""></i>
                    <b-popover
                    target="totalUsed"
                    triggers="hover focus"
                    placement="bottom"
                    :content="'Jumlah pemakaian QR'"
                    ></b-popover>
                </div>
                <div>
                    <button
                        type="button"
                        class="btn"
                        style="background-color: white; padding: 4.5px 20px; border-radius: 4px; display: flex; align-items: center; font-size: 14px; cursor: pointer; font-weight: 500; border: 1px solid #e8e8e8;"
                        @click="downloadAll">
                        <i class="fas fa-file-download mr-2"></i>
                        Download 
                    </button>
                </div>
            </div>
        </div>
        <datatable></datatable>
    </div>
</template>


<script>
import moment from 'moment'
import datatable from './children/datatable.vue'
import * as XLSX from 'xlsx'

export default {
    metaInfo : {
        title : 'QR Used by Dealer'
    },
    components : {
        datatable
    },
    data() {
        return {
            usedQr : 0,
            totalQr : 0,
        }
    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
    mounted () {
        this.fetchData()
    },
    watch : {
    },
    methods : {
        fetchData() {
            this.$http.get(`/api/qrs/qr-used-pkb`)
            .then((resp)=>{
                this.usedQr = resp.data.data.total
            })
            .catch((err)=>{console.log(err)})

            this.$http.get(`/api/qrs/qr-stock`)
            .then((resp)=>{
                this.totalQr = resp.data.data.total
            })
            .catch((err)=>{console.log(err)})
        },

        async downloadAll() {
            this.$http.get(`/api/qrs/mapping-pkb?all=1`)
                .then(async res => {
                    let response = res.data.data;
                    try {
                        const customHeaders = {
                            'qrcode': 'Kode QR',
                            'frame_no': 'Nomor Rangka',
                            'engine_no': 'Nomor Mesin',
                            'active_date': 'Tanggal Mapping',
                            'loc_code': 'Kode Dealer',
                        };
                        
                        const modifiedData = response.map(item => {
                            const newItem = {};
                            for (const [oldKey, newKey] of Object.entries(customHeaders)) {
                                if (item.hasOwnProperty(oldKey)) {
                                    if (oldKey === 'active_date') {
                                        newItem[newKey] = moment(item[oldKey]).format('DD MMM YYYY | HH:mm');
                                    } else {
                                    newItem[newKey] = item[oldKey];
                                    }
                                }
                            }

                            for (const key in item) {
                                if (!customHeaders.hasOwnProperty(key) && key !== 'day_diff') {
                                    newItem[key] = item[key];
                                }
                            }
                            return newItem;
                        });

                        const worksheet = XLSX.utils.json_to_sheet(modifiedData);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                        const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
                        const filename = `mapping_detail_qrcode_${timestamp}.csv`;
                        XLSX.writeFile(workbook, filename, { bookType: 'csv' });

                    } catch (error) {
                        console.error('Error fetching data or exporting CSV:', error);
                    }
                })
                .catch((err)=>console.log(err));
        },
    }
}
</script>